// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.example-container {
   position: relative;
   min-height: 100px;
}

app-transaction-pool {
   height: 100%;
   width: 100%;
}

.mat-table {
   max-height: 200px;
}

.example-container {
   overflow: auto;
   height: 300px;
}

table {
   width: 100%;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/view-flow/log-assign-dialog/log-assign-dialog.component.css"],"names":[],"mappings":";AACA;GACG,kBAAkB;GAClB,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,cAAc;GACd,aAAa;AAChB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":["\n.example-container {\n   position: relative;\n   min-height: 100px;\n}\n\napp-transaction-pool {\n   height: 100%;\n   width: 100%;\n}\n\n.mat-table {\n   max-height: 200px;\n}\n\n.example-container {\n   overflow: auto;\n   height: 300px;\n}\n\ntable {\n   width: 100%;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
